import React from "react";
import { useSelector } from "react-redux";


interface RootState {
  content?: {
    get?: {
      loading?: boolean;
    };
  };
}

const GlobalLoader = () => {
  const loading = useSelector((state: RootState) => state.content?.get?.loading);
  if (!loading) return null;

  return (
    <div className="pageLoaderOverlay">
      <div className="pageLoaderCard">
        <div className="pageLoaderSpinner" />
        <div className="pageLoaderLabel">Loading…</div>
      </div>
    </div>
  );
};

export default GlobalLoader;